import { IPasswordPolicy } from './IPasswordPolicy';

export abstract class RegexBasedPasswordPolicy implements IPasswordPolicy {

    private regex: RegExp;

    protected constructor(regex: RegExp) {
        this.regex = regex;
    }

    public isValid(password: string): boolean {
        return this.regex.test(password);
    }
}
